import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=39d6fa6c&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d6fa6c')) {
      api.createRecord('39d6fa6c', component.options)
    } else {
      api.reload('39d6fa6c', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=39d6fa6c&", function () {
      api.rerender('39d6fa6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23mcqioj3ftB1/JS/comp/IncreaseNumber.vue"
export default component.exports